import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetMainNewsFailed, EGetMainNewsActionType } from './types';

export const getMainNewsFailed: () => TGetMainNewsFailed = actionGenerator<EGetMainNewsActionType.Failed>(
  EGetMainNewsActionType.Failed,
);
